module.exports = __webpack_public_path__ + "static/media/sd.e229b8a5.png";